<template>
  <div class="contact-container">

    <nav-component></nav-component>

    <div class="blog-header">
      <div class="homepage-headline">
        <h1>Your Contacts</h1>
      </div>
    </div>
    <div class="center">
      <div class="left">
        <h1>Newsletter Signups</h1>
        <div v-for="email in emails">
          <p>{{ email.name }}</p>
          <hr>
        </div>
      </div>
      <div class="right">

        <h1>Contact Form Submissions</h1>

        <div v-for="contact in contacts">
            <h2>{{ contact.name }}</h2>
            <p><strong>email:</strong>
            <br>
            {{ contact.email }}</p>
            <p><strong>job:</strong>
            <br>
            {{ contact.job }}</p>
            <p><strong>phone:</strong>
            <br>
            {{ contact.phone }}</p>
            <p><strong>message:</strong>
            <br>
            {{ contact.msg }}</p>
            <hr>
        </div>
      </div>
    </div>


    <juicer></juicer>
    <site-map></site-map>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import { db } from '../firebase';
  import 'firebase'

  export default {
    data() {
      return {
        emails: [],
        newEmail: '',
        contacts: [],
      }
    },
    firestore() {
      return {
        emails: db.collection('emails'),
        contacts: db.collection('contacts')
      }
    }
  }
</script>

<style scoped lang="scss">
  * {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
  }

  .blog-header {
    width: 100%;
    height: 400px;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    background-image: url('../assets/img/blog-header.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 160px;

    a {
      color: #fff;
      text-decoration: none;

      :active, :focus {
        outline: none !important;
      }
    }
  }
  
  .homepage-headline {
    // margin: 200px 0;

    h1 {
      font-size: 44px;
      text-align: center;
      color: #fff;
      font-family: 'Times New Roman', serif;
      font-weight: bold;
      position: relative;
      top: 30px;
    }
  }

  .blog-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .blog-page-title {  }
    .blog-categories {  }
  }

  .center {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 80%;
    margin: 0 auto 160px;

    .left, .right {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      // align-items: center;
    }
    .left {
      text-align: left !important;

      .phone, .email {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;

        p {
          font-size: 26px;
          color: #2e3192;
          margin: 0;
        }
      }
    }

    .left h1, .right h1 {
      font-size: 40px;
      font-family: 'Times New Roman', serif;
      font-style : italic;
      margin-top: 0;
      margin-bottom: 20px;
    }

    .icon-holder {
      background-color: #dcdded;
      width: 45px;
      height: 45px;
      border-radius: 100%; 
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;

      img {
        width: 25px;
        height: 25px;
      }
    }

    .form-container {
      display: flex;
      flex-direction: column;
      padding: 0 30px;

      input {
        border: 1px solid #ccc !important;
        margin-bottom: 15px;
        padding: 8px;
        border-radius: 3px;
        // max-width: 400px;
        margin: 0 auto 15px;
        width: 100%;
      }

      textarea {
        border: 1px solid #ccc !important;
        padding: 8px;
        border-radius: 3px;
        // max-width: 400px;
        margin: 0 auto;
        width: 100%;
      }

      .signup-button {
        border: none;
        background-color: #2e3192;
        color: #fff;
        font-size: 20px;
        padding: 17px 20px 17px 20px;
        border-radius: 5px;
        position: relative;
        transition: all 0.15s linear;
        width: 200px;
        height: 60px;
        margin-top: 15px;
      }
      .signup-button:hover {
        background-color: #5c5eb4;
      }

      .signup-button:focus {
        outline: none;
      }
    }
  }
  @media (max-width: 775px) {
    .center { 
      flex-direction: column;
      
      .left, .right { width: 100%; }

      .left { margin-bottom: 100px; }
    }
    
  }
  
</style>


// WEBPACK FOOTER //
// src/components/ContactsViewer.vue